import React from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function ModalDeleteFAQ({ show, onHide, handleConfirmDelete, isLoadingButton }) {
    const { t } = useTranslation();

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{t('Confirm Delete')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {t('Are you sure you want to delete this FAQ?')}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {t('Cancel')}
                </Button>
                <Button variant="danger" onClick={handleConfirmDelete} disabled={isLoadingButton}>
                    {isLoadingButton ? (
                        <>
                            <Spinner animation="border" size="sm" className="me-2" />
                            {t('Delete')}
                        </>
                    ) : (
                        t('Delete')
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ModalDeleteFAQ;